import { createContext, FC, ReactNode, useContext, useMemo, useState } from "react";

type VoiceFieldFocus = {
  activeFieldId: string | null;
  setActiveFieldId: (id: string | null) => void;
};

const VoiceFieldFocusContext = createContext<VoiceFieldFocus>({
  activeFieldId: null,
  setActiveFieldId: () => undefined,
});

export const VoiceFieldFocusProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [activeFieldId, setActiveFieldId] = useState<string | null>(null);
  const value = useMemo(
    () => ({ activeFieldId, setActiveFieldId }),
    [activeFieldId],
  );
  return (
    <VoiceFieldFocusContext.Provider value={value}>
      {children}
    </VoiceFieldFocusContext.Provider>
  );
};

export const useVoiceFieldFocus = () => useContext(VoiceFieldFocusContext);
